import React, { useEffect, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

const AimHeader = ({ type }) => {
  // ハンバーガーの表示非表示
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'clip'
    } else {
      document.body.style.overflow = 'scroll'
    }

    return () => {
      document.body.style.overflow = 'scroll'
    }
  }, [open])

  return (
    <header className={`aimHeader${type ? ` aimHeader--${type}` : ''}`}>
      <div className="aimHeader__inner">
        <Link to="/aim">
          <StaticImage src="../images/logo/aim_logo_title_ja.png" className="aimHeader__logo" alt="aim" placeholder="none" width={97} />
        </Link>

        <nav>
          <ul className="aimHeader__list">
            <li className="aimHeader__listItem">
              <Link to="/aim/about" className="aimHeader__listItemLink">
                aim@の特長
              </Link>
            </li>
            <li className="aimHeader__listItem">
              <Link to="/aim/success" className="aimHeader__listItemLink">
                成功事例
              </Link>
            </li>
            <li className="aimHeader__listItem">
              <Link to="/aim/blog/" className="aimHeader__listItemLink">
                お役立ち情報
              </Link>
            </li>
            <li className="aimHeader__listItem">
              <Link to="/aim/seminar" className="aimHeader__listItemLink">
                セミナー
              </Link>
            </li>
            <li>
              <ul className="aimHeader__buttons">
                <li>
                  <Link className="aimHeader__button" to="/aim/document-form">
                    資料請求
                  </Link>
                </li>
                <li>
                  <Link className="aimHeader__button aimHeader__button--contact" to="/aim/new-kobetsu-form">
                    無料体験
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      {/* ハンバーガーメニュー */}
      <div className={`aimHeader__hamburgerMenu ${open ? 'aimHeader__hamburgerMenu--open' : ''}`}>
        <button
          className="aimHeader__hamburgerMenuButton"
          onClick={() => setOpen((prevState) => !prevState)}
          aria-label="メニュー"
          aria-expanded={open}
          aria-controls="aimHeader__hamburgerMenuList"
        >
          <span className="aimHeader__hamburgerMenuLine"></span>
          <span className="aimHeader__hamburgerMenuLine"></span>
          <span className="aimHeader__hamburgerMenuLine"></span>
        </button>
        <div className="aimHeader__hamburgerMenuWindow">
          <ul id="aimHeader__hamburgerMenuList">
            <li>
              <Link to="/aim">aim@TOP</Link>
            </li>
            <li>
              <Link to="/aim/about">aim@の特長</Link>
            </li>
            <li>
              <Link to="/aim/success">成功事例</Link>
            </li>
            <li>
              <Link to="/aim/blog">お役立ち情報</Link>
            </li>
            <li>
              <Link to="/aim/seminar">セミナー</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}
export default AimHeader
